import $ from 'jquery';
import { get } from 'styleguide/lib/props';

const $window = $(window);
const $fixedModule = $(".js-fixed-corner");
const fixedOffClass = "fixed-corner--off";
const fixedOffHpClass = "fixed-corner--hp-off";
const hasAboutTheBrand = $('#js-btt-fixed-target').length;
const $footerSurvey = $('.js-footer-survey');
const hasFooterSurvey = $footerSurvey.length;

const bottomPaddingWhenScrolling = 30; // if this number is adjusted then the CSS `bottom` needs to match this number

// AB341
// This AB Tests puts the fixed corner element inside of the bottom section of the footer. Since it's position will be
// fixed to that footer element once you reach the bottom of the page.
const AB341 = get('rcProps.abTests.ab341', false);
const $footerBottomSection = $('#js-footer-bottom-section');

if(AB341) {
  $fixedModule.attr('data-ab341', true);
  $footerBottomSection.append($(".js-fixed-corner")).css({'position': 'relative'});
  $('#country-prefs-footer').parent().attr('data-ab341-country-pref', true);
}

function fixedCorner() {

  //append ntf banner to footers wrapping div
  $fixedModule.append($("iframe#attentive_creative"));

  if ($fixedModule.length === 0) return;

  $window.on("scroll resize", function () {
    const docHeight = $(document).height();
    const windowHeight = window.screen.height;
    const scrollPosY = $window.scrollTop(); // scroll position from top of view
    const footerHeight = $("#site-footer").outerHeight(true);
    const footerHeightWOSurvey = AB341 ? $footerBottomSection.outerHeight(true) : $(".site-footer").outerHeight(true);
    let footerScrollSurveyPosY = docHeight - footerHeightWOSurvey - windowHeight + bottomPaddingWhenScrolling;
    footerScrollSurveyPosY = AB341 ? footerScrollSurveyPosY + $fixedModule.outerHeight() + 27 + 16: footerScrollSurveyPosY;
    const hasCookieBanner = $('.cookies-banner').length;
    const hasStickyAddToBag = $('.sticky-add-to-bag').length;
    footerScrollSurveyPosY = hasCookieBanner ? footerScrollSurveyPosY - 16 : footerScrollSurveyPosY ;

    if (hasFooterSurvey) {
      let designerScrollPosY = docHeight - footerHeight - windowHeight;
      designerScrollPosY = hasCookieBanner ? designerScrollPosY - 16 : designerScrollPozsY;
      const surveyHeight = -1 * $footerSurvey.height() - 16;
      const scrollAboveFooter = scrollPosY >= designerScrollPosY;
      handlePosition($fixedModule, scrollAboveFooter, hasCookieBanner, hasStickyAddToBag, surveyHeight);

      // any other page with back to top
    } else {
      const scrollAboveFooter = scrollPosY >= footerScrollSurveyPosY;
      handlePosition($fixedModule, scrollAboveFooter, hasCookieBanner, hasStickyAddToBag);
    }
  });

  // because footer is ab testing, we're updating margin on "About the brand" module
  if ($('.site-footer__spacing').length && hasAboutTheBrand) {
    $('#js-btt-fixed-target').css('margin-bottom', 0);
  }
}

function handlePosition($fixedModule, scrollAboveFooterContent, hasCookieBanner, hasStickyAddToBag, newTopValue) {
  // if scroll position is above the footer fix to page
  if (scrollAboveFooterContent) {
    $fixedModule.removeClass(fixedOffHpClass);
    $fixedModule.addClass(fixedOffClass);
    if (newTopValue) {
      $fixedModule.css({ top: newTopValue });
    }
    if (hasCookieBanner || hasStickyAddToBag) {
      $fixedModule.css({ bottom: '' });
    }
    // else position it absolute above the footer
  } else {
    $fixedModule.removeClass(fixedOffClass);
    $fixedModule.addClass(fixedOffHpClass);
    if (newTopValue) {
      $fixedModule.css({ top: '' });
    }
    if (hasCookieBanner || hasStickyAddToBag) {
      $fixedModule.css({ bottom: 32 });
    }
  }
}

// Scroll to top function
function scrollToTop() {
  $("html, body").animate({ scrollTop: 0 }, 300);
  $("html, body").find('#tr-burger-icon').focus();
}

// Handles back to top functionality and visibility
function backToTop() {
  const $backToTop = $(".back-to-top");
    //AB Test 721
    var backToTopFixed = $('.nav__link--btt');
    //AB Test 721
    if (backToTopFixed.length) {
      backToTopFixed.on("click", function(){
        scrollToTop();
    });
    }

  // Check if back to top button exist
  if ($backToTop.length === 0) return;

  // Add click event to scroll to top of page
  $backToTop.on("click", function () {
    scrollToTop();
  });

  // Show $backToTop after scrolling 150px down page
  $window.on('scroll', function () {
    const scrollPos = $(this).scrollTop()
    if (scrollPos > 150) {
      $backToTop.css('visibility', 'visible');
    } else {
      $backToTop.css('visibility', 'hidden');
    }
  });
}

// checks toast email address
function toastEmailCheck() {
  const input = $('#ntf-email-address');
  const value = input.val();
  // checks if email exists
  if (value == 'test@revolve.com') {
    $.modal({
      open: "ntf-toast--existing",
      triggerOpen: true,
      type: "toast"
    });
  } else if (value == 'new@revolve.com') {
    // checks new email
    $.modal({
      open: "ntf-toast--new",
      triggerOpen: true,
      type: "toast"
    });
  } else {
    // checks error for input field
    // back end to update error state
    input.closest('.field').addClass('is-error');
  }
}

// NTF mobile toast function
function toast() {
  const toast = $('.fixed-toast');
  const close = $('.fixed-toast--close');
  $(close).on('click', function () {
    $(toast).hide();
  });

  // email sign up form
  $('.ntf-toast--form').on('submit', function (event) {
    event.preventDefault();
    toastEmailCheck();
  });
}

// For pages with no scrolling - to reset live chat to correct fixed corner class
function removeHpOffForNoScroll() {
  const pageHasVerticalScroll = $(document).height() > $window.height();
  const noScrollLC = $('.js-no-scroll-live-chat').length > 0;
  const fixedCorner = $('.js-fixed-corner.fixed-bottom');
  const hpOffClass = 'fixed-corner--hp-off';
  const offClass = 'fixed-corner--off';

  if (!pageHasVerticalScroll && fixedCorner.length > 0 || noScrollLC && fixedCorner.length > 0) {
    fixedCorner.removeClass(hpOffClass);
    fixedCorner.addClass(offClass);
  }

  // Function to handle tab switch from inactive to active subscriptions tab to reset the fixed-corner class for Replenish & Save page if customer has active or inactive subscriptions
  function handleTabSwitch(tabName) {
    if (tabName === 'active-subscriptions') {
      $(fixedCorner).removeClass(hpOffClass);
      $(fixedCorner).addClass(offClass);
    } else if (tabName === 'inactive-subscriptions') {
      $(fixedCorner).removeClass(offClass);
      $(fixedCorner).addClass(hpOffClass);
    }
  }

  $('.tabs__nav .tabs__link').on('click', function (e) {
    e.preventDefault();
    const tabName = $(this).attr('href').substring(1);
    handleTabSwitch(tabName);
  });
}


$(document).ready(function () {
  fixedCorner();
  backToTop();
  toast();
  removeHpOffForNoScroll();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/fixed-corner.js